import { IssuerStatus, SuperintendentStatus } from "@ha/data/basic";

export interface SubscriptionInvitation {
    subscriptionId: number;
    subscriptionName: string;
    issuerStatus: IssuerStatus;
    superintendentStatus: SuperintendentStatus;
    invitationType: SubscriptionInvitationType;
}

export enum SubscriptionInvitationType {
    Issuer = 1,
    Superintendent = 2,
}
